export default __webpack_public_path__ + "static/media/Beehaz_08_grow_with_you.029c03f7.png";